import { html } from "lit";
var icon_paste_default = () => html`
  <svg viewBox="0 0 27 28" xmlns="http://www.w3.org/2000/svg">
    <g fill-rule="nonzero">
      <path
        d="M25.26 7.5H14.7c-.9 0-1.63.72-1.63 1.62v13.83c0 .9.73 1.61 1.63 1.61h6.16c.43 0 .84-.17 1.15-.47l4.4-4.35c.3-.3.48-.71.48-1.14V9.12c0-.9-.73-1.62-1.63-1.62ZM14.7 9.13h10.56v9.46l-4.4 4.35H14.7V9.12Z" />
      <path
        d="M25.26 17.25a.81.81 0 0 1 .1 1.62H21.21l-.01.02v4.05a.81.81 0 0 1-1.62.1V18.89c0-.86.65-1.56 1.5-1.63l.13-.01h4.05Z" />
      <g>
        <path
          d="M15.56.26H6.94a.81.81 0 0 0-.8.81v3.45c0 .45.36.81.8.81h8.62c.45 0 .81-.36.81-.81V1.07a.81.81 0 0 0-.8-.81Zm-.81 1.63V3.7h-7V1.89h7Z" />
        <path
          d="M19 1.98c1.25 0 2.05.64 2.38 1.74.09.3.14.57.17.91l.02.3.01.36v.62l-.03 1.64v.22a.81.81 0 0 1-1.63 0v-.62l.04-1.23V5.2l-.01-.15-.02-.26v-.11l-.04-.22-.07-.27c-.11-.4-.28-.56-.7-.58h-3.56a.81.81 0 0 1-.1-1.62H19.01Z" />
        <path
          d="M6.94 1.98a.81.81 0 0 1 .1 1.62H3.5a.91.91 0 0 0-.9.81l-.01.11V25.2c0 .47.35.85.8.9l.1.01h15.52c.47 0 .85-.35.9-.8l.01-.1v-1.02a.81.81 0 0 1 1.62-.1v1.11a2.54 2.54 0 0 1-2.36 2.53H3.5a2.54 2.54 0 0 1-2.53-2.36V4.52a2.54 2.54 0 0 1 2.36-2.53h3.61Z" />
      </g>
    </g>
  </svg>
`;
export {
  icon_paste_default as default
};
//# sourceMappingURL=icon-paste.js.map
